export const unlockFileConstants = {
  UNLOCK_REQUEST: 'UNLOCK_REQUEST',
  UNLOCK_ERROR: 'UNLOCK_ERROR',
  UNLOCK_SUCCESS: 'UNLOCK_SUCCESS',
  CLEAR: 'UNLOCK_CLEAR',
};
